import { Dispatch } from 'redux';
import { redirect, StateGetter, Bag } from 'redux-first-router';

import * as types from 'dux/router/types';
import { programs } from '@biw/contests-core';
import { getActiveProgramViewId, getActiveProgram } from 'app/dux/router/selectors';

async function getContest( dispatch: Dispatch, getState: StateGetter ) {
    const programViewId = getActiveProgramViewId( getState() );
    if ( !programViewId ) {
        return null;
    }

    let programView = getActiveProgram( getState() );
    if ( !programView ) {
        const action = programs.actions.getProgramView( programViewId );

        await dispatch( action as any ).catch( () => null );
        programView = programs.selectors.getProgram( getState(), programViewId );
    } else {
        // if the programView was found in the store, send an async request to update the data
        dispatch( programs.actions.getProgramView( programViewId ) as any );
    }

    return programView;
}
// =======================
// Types
// =======================
interface Module {
    default: React.ComponentType;
}

export type RouteHook = (dispatch: Dispatch, getState: StateGetter, bag?: Bag) => void;
export interface RouteDefinition {
    path: string;
    requiresAuth?: boolean;
    getComponent?: () => Promise<Module>;
    beforeEnter?: RouteHook;
    afterEnter?: RouteHook;
}

interface RouteMap {
    [key: string]: RouteDefinition;
}

export default {
    [ types.INDEX ]: {
        path: '/',
        beforeEnter: (dispatch) => dispatch(redirect( { type: types.DASHBOARD })),
    },
    [ types.DASHBOARD ]: {
        path: '/contests',
        requiresAuth: true,
        getComponent: () => import( 'routes/dashboard' ),
        afterEnter: async ( dispatch, getState ) => {
            const fetchPromise = dispatch( programs.actions.getProgramViews() as any );
            const data = programs.selectors.getProgramViews( getState() );
            return data.length === 0 && fetchPromise; // returning the promise will block route transition, we only want to do that if there isn't already data there
        },
    },
    [ types.PROGRAM_VIEW ]: {
        path: '/contests/:programViewId',
        requiresAuth: true,
        afterEnter: async ( dispatch, getState ) => {
            const program = await getContest(dispatch, getState);

            const type = types.PROGRESS; // selectors.getDefaultRouteForProgram( program );
            if ( program ) {
                dispatch( redirect( { type, payload: { programViewId: program.programViewId }} ) );
            } else {
                dispatch( redirect( { type: types.DASHBOARD } ) );
            }
        },
    },
    [ types.PROGRESS ]: {
        path: '/contests/:programViewId/progress',
        requiresAuth: true,
        getComponent: () => import('routes/progress'),
        afterEnter: async (dispatch, getState) => {
            const program = await getContest(dispatch, getState);

            if (!program) {
                return dispatch(redirect({ type: types.DASHBOARD }));
            }
        },
    },
    [ types.PROFILE ]: {
        path: '/profile',
        requiresAuth: true,
        getComponent: () => import( 'routes/profile' ),
    },
    [ types.INVALID_ROUTE ]: {
        path: '/not-found',
        getComponent: () => import( 'routes/invalid-route' ),
    },
} as RouteMap;
